import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ListingCard from "@/components/ListingCard";
import SearchBar from "@/components/SearchBar";

export default function SearchPage() {
  const [params] = useSearchParams();
  const [docks, setDocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const lake = params.get("lake");
  const q = params.get("q");
  const duration = params.get("duration");

  useEffect(() => {
    setLoading(true);
    const query = {};
    if (lake) query.lake = lake;
    if (q) query.q = q;
    if (duration) query.duration = duration;
    api.get("/docks", { params: query }).then((r) => setDocks(r.data.docks)).finally(() => setLoading(false));
  }, [lake, q, duration]);

  return (
    <div data-testid="search-page" className="container-editorial py-12">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.3em] text-accent mb-3">Available Docks</div>
        <h1 className="font-display text-4xl">
          {lake ? `On ${lake}` : q ? `Matching “${q}”` : "All waterways, all slips"}
        </h1>
        <p className="text-muted-foreground mt-2">
          {docks.length} {docks.length === 1 ? "slip" : "slips"}
          {duration ? ` available ${duration}` : " for rent"}
        </p>
      </div>
      <div className="mb-10"><SearchBar variant="page" /></div>
      {loading ? (
        <div className="text-muted-foreground">Loading…</div>
      ) : docks.length === 0 ? (
        <div data-testid="no-results" className="rounded-xl border border-dashed border-border p-16 text-center text-muted-foreground">
          No docks match your search yet. Try widening your filters.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {docks.map((d) => <ListingCard key={d.dock_id} dock={d} />)}
        </div>
      )}
    </div>
  );
}
